export const toggleRegisterLoad = flag => {
  return {
    type: flag ? "SHOW_REGISTER_BUTTON_LOADER" : "HIDE_REGISTER_BUTTON_LOADER"
  }
}
